import { infiniteQueryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { FIRST_PAGE, getNextPageFromMeta } from '@/api/pagination';
import { STALE_TIME } from '@/api/staleTimes';
import type { DcrApproveResponse, DcrApproveSearch } from '../types/dcrApprove.types';
import { dcrApproveResponseSchema } from '../types/dcrApprove.types';

const DEFAULT_DCR_APPROVE_PAGE_SIZE = 50;

export const dcrApproveQueryKeys = {
  all: () => ['dcr-approve'] as const,
  search: (params: DcrApproveSearch) => [...dcrApproveQueryKeys.all(), params] as const,
};

export const dcrApproveInfiniteQueryOptions = (params: DcrApproveSearch) =>
  infiniteQueryOptions({
    queryKey: dcrApproveQueryKeys.search(params),
    queryFn: async ({ pageParam }): Promise<DcrApproveResponse> => {
      const res = await apiClient.get(API.billing.dcrApproveSearch, {
        params: { ...params, page: pageParam, pageSize: DEFAULT_DCR_APPROVE_PAGE_SIZE },
      });
      return dcrApproveResponseSchema.parse(res.data);
    },
    initialPageParam: FIRST_PAGE,
    getNextPageParam: getNextPageFromMeta,
    staleTime: STALE_TIME,
  });
